import React from 'react';
import { ToastContainer as ReactToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Custom toast container component with themed styling
export const WeeklyPlanToastContainer = () => {
  return (
    <ReactToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={true}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="dark"
      style={{ zIndex: 99999 }}
    />
  );
};

// Export custom toast functions for consistent styling
export const showSuccessToast = (message, options = {}) => {
  toast.success(message, {
    ...options,
    className: 'weekly-plan-toast-success',
    progressClassName: 'weekly-plan-toast-progress-success'
  });
};

export const showErrorToast = (message, options = {}) => {
  toast.error(message, {
    ...options,
    className: 'weekly-plan-toast-error',
    progressClassName: 'weekly-plan-toast-progress-error'
  });
};

export const showInfoToast = (message, options = {}) => {
  toast.info(message, {
    ...options,
    className: 'weekly-plan-toast-info',
    progressClassName: 'weekly-plan-toast-progress-info'
  });
};

export const showWarningToast = (message, options = {}) => {
  toast.warning(message, {
    ...options,
    className: 'weekly-plan-toast-warning',
    progressClassName: 'weekly-plan-toast-progress-warning'
  });
};